













































































































































import { Component, Vue } from "vue-property-decorator";
import ApolloClient from "@/apollo";
import gql from "graphql-tag";
import LabelSelector from "@/components/LabelSelector.vue";
import ILabel from "@/types/label";

@Component({
  components: {
    LabelSelector
  }
})
export default class Home extends Vue {
  labels = [] as ILabel[];
  fetchLoader = false;

  selectedLabels = [] as number[];

  editLabelDialog = false;
  editLabelLoader = false;
  editingLabel = null as ILabel | null;
  editLabelName = "";
  editLabelAliases = [];
  validEditing = false;

  createLabel = false;
  createLabelLoader = false;
  createLabelName = "";
  createLabelAliases = [];
  validCreation = false;

  labelNameRules = [v => (!!v && !!v.length) || "Invalid label name"];

  labelSearchQuery = "" as string | null;

  openEditDialog(label: any) {
    this.editLabelDialog = true;
    this.editingLabel = label;
    this.editLabelName = label.name;
    this.editLabelAliases = label.aliases;
  }

  get selectedLabelsIDs() {
    return this.selectedLabels.map(i => this.labels[i]._id);
  }

  async sleep(ms: number) {
    return new Promise(r => setTimeout(r, ms));
  }

  async editLabel() {
    if (!this.editingLabel) return;
    if (!this.validEditing) return;

    await this.sleep(50);
    this.editLabelLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: LabelUpdateOpts!) {
          updateLabels(ids: $ids, opts: $opts) {
            _id
            name
            aliases
            thumbnail {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.editingLabel._id],
        opts: {
          name: this.editLabelName,
          aliases: this.editLabelAliases
        }
      }
    })
      .then(res => {
        const index = this.labels.findIndex(
          // @ts-ignore
          l => l._id == this.editingLabel._id
        );

        if (index > -1) {
          const label = this.labels[index];
          Object.assign(label, res.data.updateLabels[0]);
          Vue.set(this.labels, index, label);
        }

        this.editLabelDialog = false;
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.editLabelLoader = false;
      });
  }

  deleteLabels() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeLabels(ids: $ids)
        }
      `,
      variables: {
        ids: this.selectedLabelsIDs
      }
    })
      .then(() => {
        for (const id of this.selectedLabelsIDs) {
          this.labels = this.labels.filter(l => l._id != id);
        }
        this.selectedLabels = [];
      })
      .catch(error => {
        console.error(error);
      });
  }

  addLabel() {
    if (!this.validCreation) return;

    this.createLabelLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($name: String!, $aliases: [String!]) {
          addLabel(name: $name, aliases: $aliases) {
            _id
            name
            aliases
            thumbnail {
              _id
            }
          }
        }
      `,
      variables: {
        name: this.createLabelName,
        aliases: this.createLabelAliases
      }
    })
      .then(res => {
        //this.labels.push(res.data.addLabel);
        //this.labels.sort((a, b) => a.name.localeCompare(b.name));
        this.labels = [];
        this.selectedLabels = [];
        this.createLabel = false;
        this.createLabelName = "";
        this.createLabelAliases = [];
        this.getLabels();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.createLabelLoader = false;
      });
  }

  labelAliases(label: any) {
    return label.aliases
      .slice()
      .sort()
      .join(", ");
  }

  getLabels() {
    this.fetchLoader = true;
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
            thumbnail {
              _id
            }
          }
        }
      `
    })
      .then(res => {
        this.labels = res.data.getLabels;
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  beforeMount() {
    this.getLabels();
  }
}
